import React from "react";
import {AccountsTree} from "../../components";

export const AccountsTreePage = () => {
    return <AccountsTree/>;
};
